import { CheckCircle, XCircle, ArrowRight } from "lucide-react";

const ProblemSolutionSection = () => {
  const problems = [
    "Gestion complexe des assurances et visas",
    "Inquiétudes sur la productivité à distance",
    "Conformité légale et fiscale internationale",
    "Manque de visibilité sur les équipes nomades",
    "Coûts administratifs élevés"
  ];

  const solutions = [
    "Accompagnement complet automatisé",
    "Outils de suivi et reporting intégrés",
    "Conformité garantie par nos experts",
    "Dashboard centralisé temps réel",
    "Modèle économique transparent"
  ];

  return (
    <section className="py-24 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Le télétravail international : 
            <span className="text-primary block">un casse-tête pour les RH ?</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Les entreprises veulent offrir plus de flexibilité à leurs équipes, 
            mais se heurtent à des défis opérationnels majeurs.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Problèmes */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
                <XCircle className="h-4 w-4" />
                Les défis actuels
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-4">
                Sans solution adaptée
              </h3>
            </div>
            
            <div className="space-y-4">
              {problems.map((problem, index) => (
                <div key={index} className="flex items-start gap-4 p-4 bg-white rounded-lg border border-red-100">
                  <XCircle className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" />
                  <span className="text-foreground">{problem}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Solutions */}
          <div className="space-y-8">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
                <CheckCircle className="h-4 w-4" />
                Avec RENEST
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-4">
                Tout devient simple
              </h3>
            </div>
            
            <div className="space-y-4">
              {solutions.map((solution, index) => (
                <div key={index} className="flex items-start gap-4 p-4 bg-white rounded-lg border border-green-100">
                  <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <span className="text-foreground">{solution}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Arrow between columns */}
        <div className="hidden lg:flex justify-center my-12">
          <div className="bg-primary text-primary-foreground p-4 rounded-full">
            <ArrowRight className="h-8 w-8" />
          </div>
        </div>

        {/* Solution statement */}
        <div className="text-center mt-16 p-8 bg-primary/5 rounded-2xl border border-primary/20">
          <h3 className="text-3xl font-bold text-primary mb-4">
            RENEST = La première plateforme tout-en-un pour le télétravail international
          </h3>
          <p className="text-lg text-muted-foreground max-w-4xl mx-auto leading-relaxed">
            Nous transformons la complexité du télétravail international en une expérience fluide 
            et sécurisée, tant pour les RH que pour les collaborateurs.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolutionSection;